module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_8.15c2d57a.png";